const SHORT_MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

const LONG_MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** Parse YYYY-MM-DD without timezone drift (no Date parsing). */
function parseIsoDate(iso) {
  const [year, month, day] = String(iso || '').split('-');
  return {
    year: year || '',
    month: Number(month) || 0,
    day: Number(day) || 0,
  };
}

/** e.g. 2024-03-15 → "Mar 2024" */
export function formatMonthYear(iso) {
  const { year, month } = parseIsoDate(iso);
  if (!year || month < 1 || month > 12) return '';
  return `${SHORT_MONTHS[month - 1]} ${year}`;
}

/** e.g. 2024-03-15 → "15 March 2024" (en-IN style, deterministic). */
export function formatDayMonthYear(iso) {
  const { year, month, day } = parseIsoDate(iso);
  if (!year || month < 1 || month > 12 || !day) return '';
  return `${day} ${LONG_MONTHS[month - 1]} ${year}`;
}

/** e.g. 2024-03-15 → "March 2024" */
export function formatLongMonthYear(iso) {
  const { year, month } = parseIsoDate(iso);
  if (!year || month < 1 || month > 12) return '';
  return `${LONG_MONTHS[month - 1]} ${year}`;
}

/**
 * Deterministic integer grouping for SSR + client (avoids hydration
 * mismatches from bare `n.toLocaleString()` using the browser locale).
 */
export function formatInt(n) {
  return Number(n).toLocaleString('en-US');
}
